import React, { useState } from "react";
import loginimg from "../../assets/images/connection.png";
import { Stack, Typography } from "@mui/material";
import "../../assets/css/login.css";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import { fetchUserScope, getUserDetails, login } from "../../utils/services";
import { enqueueSnackbar } from "notistack";
import { useUserContext } from "../../context/UserContext";
import { Loading } from "../../components";
import { Breakpoint } from "../../utils/theme";
import TataSTRIVE from "../../assets/images/TataSTRIVE-white.png";

const Login = () => {
  const [state, setState] = useState({
    userName: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const isMob = Breakpoint();

  const { setUser, programId,  mentorRole,adminRole,} = useUserContext();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((oldState) => ({
      ...oldState,
      [name]: value,
    }));
  };

  const responseGoogle = (response) => {
    setLoading(true);
    try {
      const token = response.getAuthResponse().id_token;
      const dupState = {
        token: token,
        action: "socialAccountLogin",
        userName: "",
        password: "",
      };
      userLogin(dupState);
    } catch (error) {
      setLoading(false);
    }
  };

  const userLogin = async ({ token, action, userName, password }) => {
  try {
    const response = await login(token, action, userName, password);

    if (response.status === "faliure") {
      const error = response.appError[0].errorMessage;
      enqueueSnackbar(error, { variant: "error" });
      setLoading(false);
    } else {
      let obj = JSON.parse(response.data);
      const data = getUserDetails(obj);

      const mentorScope = await fetchUserScope(
        data.token,
        data.id,
        programId,
        mentorRole
      );

      const adminScope = await fetchUserScope(
        data.token,
        data.id,
        programId,
        adminRole
      );

      const isMentor =
        mentorScope.status === "success" &&
        JSON.parse(mentorScope.data);

      const isAdmin =
        adminScope.status === "success" &&
        JSON.parse(adminScope.data);

      if (isMentor || isAdmin) {
        data.isAdmin = isAdmin;
sessionStorage.setItem("token", data.token);
        setUser(data);

        navigate("/dashboard");

        // enqueueSnackbar(
        //   ${data.firstName} ${data.lastName ?? ""} logged in successfully!,
        //   {
        //     variant: "success",
        //   }
        // );
      } else {
        enqueueSnackbar("Access Denied", {
          variant: "error",
        });
      }

      setLoading(false);
    }
  } catch (error) {
    enqueueSnackbar("Something went wrong! Please try again later.", {
      variant: "error",
    });
    setLoading(false);
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();

    if (state.userName == "") {
      enqueueSnackbar("Username is required!", { variant: "error" });
      return;
    }

    if (state.password == "") {
      enqueueSnackbar("Password is required!", { variant: "error" });
      return;
    }
    setLoading(true);
    userLogin({
      token: "",
      action: "login",
      userName: state.userName,
      password: state.password,
    });
  };

  return isMob ? (
    <div className="login-container-mob">
      <Stack
        alignItems="center"
        justifyContent="center"
        className="blue-bg-mob"
      >
        <img
          src={TataSTRIVE}
          style={{
            height: "40px",
            marginBottom: "15px",
          }}
        />

        <img src={loginimg} alt="login-img" className="login-img" />
        <Typography variant="h6" className="login-text">
          Connect with your facilitator
        </Typography>
      </Stack>
      <div className="grey-bg-mob">
        <LoginForm
          state={state}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          responseGoogle={responseGoogle}
        />
      </div>

      <Loading open={loading} />
    </div>
  ) : (
    <div className="login-container-desk">
      <Stack direction="row" minHeight="70%" minWidth="80%">
        <Stack
          alignItems="center"
          justifyContent="center"
          className="blue-bg-desk"
        >
          <img
            src={TataSTRIVE}
            style={{
              height: "50px",
              marginBottom: "15px",
              alignSelf: "start",
              paddingLeft: "50px",
            }}
          />
          <img src={loginimg} alt="login-img" className="login-img" />
          <Typography variant="h6" className="login-text">
            Connect with your facilitator
          </Typography>
        </Stack>
        <Stack
          alignItems="center"
          justifyContent="center"
          className="grey-bg-desk"
        >
          <div className="login-wrapper-desk">
            <LoginForm
              state={state}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              responseGoogle={responseGoogle}
            />
          </div>
        </Stack>
      </Stack>
      <Loading open={loading} />
    </div>
  );
};

export default Login;